export class ManageAuditProgramDto {
    clientId: string;
    auditFirmIds: string;
    firmName: string;
    auditProgramId: string;
    auditName: string;
    auditCoverage: string;
    isTriggered: string;
    cdAuditStatus: string;
    auditWfReqId: string;
    auditWfReqStatusId: string;
    processCount: string;
    enableWorkflow: string;
    usedInAuditProgramCount: string;
    templateId: string;
    statusId: string;
    pending: string = "0";
    partiallyCompleted: string = "0";
    accepted: string = "0";
    partiallyAccepted: string = "0";
    callingType: string;
    callingFrom: string;
    notAccepted: string = "0";

    completed: string = "0";
    auditeeRemarks: string;

    createdByName: string;
    updatedByName: string;
    sCreateDate: string;
    sUpdateDate: string;
    state: string;
    isopen: boolean = false;

    triggeredDate: string;
    triggeredBy: string;
    auditPeriod: string;

    financialYearName: string;
    quarterName: string;
    companyName: string;
    siteName: string;
    airTemplateId: string;
    siteId: string;

    financialYearId: string;
    quarterId: string;
    auditPeriodFromDate: string;
    auditPeriodToDate: string;
    auditCoveragePeriodFromDate: string;
    auditCoveragePeriodToDate: string;
    ncCount: string;
    shortFinancialYear: string;
    auditProgramNameMinimized: string;
    isDraftReportReleased: number;
    createdByEmail: string;
    modifiedByEmail: string;
    triggeredByEmail: string;
    statusClass: string;
    suffix: string;

    editAudit: string = "";
    tabName: string = "";
    triggerState: string = "";


    permissionFlag: any;
    departmentHeaderRole: any;
    departmentGridRoles: {
        departmentName: any,
        departmentRoles: {
            departmentRoleName: any,
            departmentRoleValue: any
        };
    };
    enableAllTransaction: string;
    enableShowAllRecords: string;
    isTriggeredAudit: string = "N";
    reportReleaseDate: string;
    projectCode: string;
}